
import { useState, useEffect } from 'react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-lg' : 'bg-white shadow-sm'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo and Company Name */}
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-orange-500 rounded-lg flex items-center justify-center">
              <i className="ri-shield-check-line text-white text-xl"></i>
            </div>
            <div>
              <h1 className="text-xl font-bold text-gray-900">Home Security Advisors</h1>
              <div className="flex items-center space-x-1">
                <div className="flex text-yellow-400">
                  <i className="ri-star-fill text-sm"></i>
                  <i className="ri-star-fill text-sm"></i>
                  <i className="ri-star-fill text-sm"></i>
                  <i className="ri-star-fill text-sm"></i>
                  <i className="ri-star-fill text-sm"></i>
                </div>
                <span className="text-sm text-gray-600">4.9/5</span>
              </div>
            </div>
          </div>

          {/* Trust Badges with Borders */}
          <div className="hidden md:flex items-center space-x-4">
            <div className="text-center border border-gray-300 rounded-lg px-3 py-2">
              <div className="text-sm font-semibold text-gray-900">BBB A+</div>
            </div>
            <div className="text-center border border-gray-300 rounded-lg px-3 py-2">
              <div className="text-sm font-semibold text-gray-900">TCPA Compliant</div>
            </div>
            <div className="text-center border border-gray-300 rounded-lg px-3 py-2">
              <div className="text-sm font-semibold text-gray-900">24/7 Service</div>
            </div>
          </div>

          {/* Call Button */}
          <div className="flex items-center">
            <button className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded-lg font-medium flex items-center space-x-2 whitespace-nowrap cursor-pointer">
              <i className="ri-phone-line"></i>
              <span>Call Now for Instant Quote: 7027601474</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
